import { Col, Row } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";

const MediaCard = ({ label, path }) => {
  const url = getJeepRallyMediaUrl(path);

  return (
    <div className="h-100">
      <div className="text-muted small mb-2">{label}</div>
      <div
        className="d-flex align-items-center justify-content-center overflow-hidden border rounded bg-light"
        style={{ minHeight: 180 }}
      >
        {url ? (
          <img
            src={url}
            alt={label}
            style={{
              width: "100%",
              maxHeight: 220,
              objectFit: "cover",
            }}
          />
        ) : (
          <span className="text-muted small">No image uploaded</span>
        )}
      </div>
    </div>
  );
};

const RallyMediaSection = ({ rally }) => {
  return (
    <div className="mb-0">
      <h5 className="mb-3">Media</h5>
      <Row className="g-3">
        <Col md={6}>
          <MediaCard
            label="Banner"
            path={rally?.banner_image || rally?.coverImage}
          />
        </Col>
        <Col md={6}>
          <MediaCard label="Thumbnail" path={rally?.thumbnail_image} />
        </Col>
      </Row>
    </div>
  );
};

export default RallyMediaSection;
